var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34306 5.20206C4.78377 5.17058 5.16655 5.50232 5.19802 5.94303L5.94495 16.4L14.0551 16.4L14.8021 5.94303C14.8336 5.50232 15.2163 5.17058 15.657 5.20206C16.0977 5.23354 16.4295 5.61632 16.398 6.05702L15.6511 16.514C15.5913 17.3513 14.8946 18 14.0551 18H5.94495C5.10553 18 4.40883 17.3513 4.34902 16.514L3.60209 6.05702C3.57062 5.61632 3.90236 5.23354 4.34306 5.20206Z",
    fill: "#E51A32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00003 5.99999C2.00003 5.55816 2.3582 5.19999 2.80003 5.19999H17.2C17.6418 5.19999 18 5.55816 18 5.99999C18 6.44182 17.6418 6.79999 17.2 6.79999H2.80003C2.3582 6.79999 2.00003 6.44182 2.00003 5.99999Z",
    fill: "#E51A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 3.6C6.00002 2.71634 6.71637 2 7.60002 2H12.4C13.2837 2 14 2.71634 14 3.6V5.19999C14 5.64182 13.6418 5.99999 13.2 5.99999C12.7582 5.99999 12.4 5.64182 12.4 5.19999V3.6H7.60002V5.19999C7.60002 5.64182 7.24185 5.99999 6.80002 5.99999C6.35819 5.99999 6.00002 5.64182 6.00002 5.19999V3.6Z",
    fill: "#E51A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconNew);
export default __webpack_public_path__ + "static/media/delete-icon-new.671fcf72fc852f78d136b80c2da83675.svg";
export { ForwardRef as ReactComponent };